import React from "react";
import {
  WSButton,
  WSCard,
  WSGrid,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import {
  IMeridioPlanCatalogCategory,
  IMeridioPlanOption
} from "../../../../services/api/benefits/meridioPlanCatalog/types";
import { PlanCard } from "./PlanCard";
import { openMeridioGuidebook } from "../../utils";

interface PlanCategorySectionProps {
  category: IMeridioPlanCatalogCategory;
}

function getStartingPrice(plans: IMeridioPlanOption[]): number | undefined {
  const prices = plans
    .map(p => p.io?.monthlyPremium)
    .filter((p): p is number => p !== undefined);
  return prices.length > 0 ? Math.min(...prices) : undefined;
}

function getCategoryDescription(category: IMeridioPlanCatalogCategory): string {
  const startingPrice = getStartingPrice(
    category.plans as IMeridioPlanOption[]
  );
  const priceLabel =
    startingPrice !== undefined
      ? ` starting at ${formatMoney(startingPrice, Currency.USD)}/month`
      : "";

  switch (category.category) {
    case "HealthInsurance":
      return `Medical coverage for you and your family - ${category.plans.length} plan options${priceLabel}`;
    case "VoluntaryBenefits":
      return `Optional add ons for additional coverage or support during major medical events${priceLabel}`;
    case "DentalVision":
      return `Dental and vision care in one plan - choose between preventative or comprehensive${priceLabel}`;
    default:
      return category.description ?? "";
  }
}

export const PlanCategorySection: React.FC<PlanCategorySectionProps> = ({
  category
}) => {
  return (
    <WSCard mb="M">
      <WSSectionToolbar title={category.name} />
      <WSText.ParagraphSm color="gray500" mb="M">
        {getCategoryDescription(category)}
      </WSText.ParagraphSm>
      <WSGrid gutter="M">
        {category.plans.map(plan => (
          <WSGrid.Item key={plan.baseSku} span={{ s: "12", m: "6" }}>
            <PlanCard plan={plan} />
          </WSGrid.Item>
        ))}
      </WSGrid>
      <WSButton.Link
        rightIcon="chevron-right"
        onClick={openMeridioGuidebook}
        mt="M"
      >
        View all plan details
      </WSButton.Link>
    </WSCard>
  );
};
